module.exports = __webpack_public_path__ + "img/jifen.5eb9967f.png";